import { TableRow, TableCell } from "@material-ui/core"; 
import { createStyles, withStyles, Theme } from '@material-ui/core/styles';

export const StyledTableCell = withStyles(() =>
  createStyles({
    body: {
      fontSize: 14,
    },
  }),
)(TableCell);

export const StyledTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }),
)(TableRow);